module.exports = __webpack_public_path__ + "img/wyh-image-1.3a451539.jpg";